import { render, staticRenderFns } from "./strengths.vue?vue&type=template&id=92a54a92&scoped=true&"
import script from "./strengths.vue?vue&type=script&lang=js&"
export * from "./strengths.vue?vue&type=script&lang=js&"
import style0 from "./strengths.vue?vue&type=style&index=0&id=92a54a92&lang=scss&scoped=true&"
import style1 from "./strengths.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a54a92",
  null
  
)

export default component.exports